let admin = {
    name: "姓名",
    enterName: "请输入姓名",
    email: "邮箱",
    enterEmail: "请输入邮箱",
    mailFormat: "请检查邮箱格式",
    type: "类型",
    primaryAdministrator: "超级管理员",
    ordinaryAdministrator: "普通管理员",
    phone: "手机号",
    enterPhone: "手机号",
    phoneFormat: "请检查手机号格式",
    pwdSetTime: "密码设置时间",
    loginErrorCnt: "登录失败次数",
    lockTime: "锁定时间",
    lastLoginTime: "上次登录时间",
    loginCount: "登录次数",
    perm: "管理员权限",
    all: "全部",
    part: "部分",
    adminDetail: "管理员详情",
    addAdmin: "添加管理员",
    updateAdmin: "编辑管理员",
    confirmDeleteAdmin: "是否要删除勾选的管理员？",
    noSelectedKeys: "选择需要删除的管理员"
}

export default admin
